import { useTimeZoneStore } from '../../../store/useTimeZoneStore'

const OPTIONS = [
  { value: 'UTC',           label: 'UTC' },
  { value: 'CET',           label: 'SEČ' },
  { value: 'Europe/Prague', label: 'Místní' },
]

export function TimeZonePicker({ trailing }) {
  const { tz, setTz } = useTimeZoneStore()

  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs text-gray-400 font-medium uppercase tracking-wide">Čas</span>
      <div className="flex items-center gap-1">
        {OPTIONS.map(opt => (
          <button
            key={opt.value}
            onClick={() => setTz(opt.value)}
            className={`px-2 py-0.5 text-xs rounded border transition-colors ${
              tz === opt.value
                ? 'bg-gray-700 text-white border-gray-700'
                : 'bg-white text-gray-600 border-gray-300 hover:border-gray-500'
            }`}
          >
            {opt.label}
          </button>
        ))}
        {trailing && <div className="ml-2 flex items-center gap-1">{trailing}</div>}
      </div>
    </div>
  )
}
